var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgELearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.996,
    height: 40,
    viewBox: "0 0 39.996 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e-learning",
    d: "M33.163,5.153a6.666,6.666,0,0,0-8.332-4.9l-2.873.822A4.968,4.968,0,0,0,20,2.168a4.968,4.968,0,0,0-1.96-1.09L15.165.257a6.666,6.666,0,0,0-8.324,4.9A8.332,8.332,0,0,0,0,13.334V25a8.342,8.342,0,0,0,8.332,8.332h10v3.333h-5a1.666,1.666,0,1,0,0,3.333H26.664a1.666,1.666,0,1,0,0-3.333h-5V33.332h10A8.342,8.342,0,0,0,40,25V13.334a8.332,8.332,0,0,0-6.833-8.181Zm-11.5.733a1.666,1.666,0,0,1,1.208-1.6l2.875-.822A3.333,3.333,0,0,1,30,6.668V13.23a3.343,3.343,0,0,1-2.416,3.2l-5.916,1.69ZM11.332,4a3.321,3.321,0,0,1,2.916-.538l2.875.822a1.666,1.666,0,0,1,1.208,1.6V18.121l-5.916-1.69A3.343,3.343,0,0,1,10,13.23V6.668A3.311,3.311,0,0,1,11.332,4ZM36.663,25a5,5,0,0,1-5,5H8.332a5,5,0,0,1-5-5V13.334A5,5,0,0,1,6.666,8.641v4.59A6.689,6.689,0,0,0,11.5,19.638l5.751,1.645a10.031,10.031,0,0,0,5.5,0L28.5,19.638a6.689,6.689,0,0,0,4.83-6.408V8.641a5,5,0,0,1,3.333,4.693Z",
    transform: "translate(0 0.002)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearning);
export default __webpack_public_path__ + "static/media/e-learning.2463f4a2cbd6feac6c535973b0a1dcbf.svg";
export { ForwardRef as ReactComponent };